var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`unit-${_vm.unitName}`,attrs:{"id":"app"}},[_c('router-view'),(_vm.showThemeSelector)?_c('theme-selector',{attrs:{"current-theme":_vm.currentTheme},on:{"change-theme":_vm.selectTheme}}):_vm._e(),_c('cookie-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }